import { FC } from 'react';
import styled from '@emotion/styled';
import Image from '@base/Image';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Button from '@base/Button/Button';
import Paper from '@base/Paper/Paper';
import { DST } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/utils';

const Container = styled(Paper)`
  display: none;
  ${mediaQuery.aboveTablet} {
    position: relative;
    padding: ${Spacings.SPACING_12B};
    display: flex;
    background-image: url(/static/images/dst/unattempted-background.svg);
    background-repeat: no-repeat;
    background-position: 100%;
  }
`;

const ContentDiv = styled.div`
  margin-right: ${Spacings.SPACING_12B};
  flex: 1;
`;

const Heading = styled.div`
  font-size: ${Fonts.H3};
  font-weight: ${Fonts.HEAVY};
  line-height: 28px;
  color: var(--color-text-primary);

  span {
    margin-left: ${Spacings.SPACING_1B} !important;
  }
`;

const SubHeader = styled.div`
  font-size: ${Fonts.H5};
  line-height: 22px;
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
`;

const Points = styled.div`
  display: flex;
  margin-top: ${Spacings.SPACING_5B};
`;

const Point = styled.div`
  margin-right: ${Spacings.SPACING_4B};
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${Fonts.H6};
  line-height: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
  margin-left: ${Spacings.SPACING_1B};
`;

const StyledBtn = styled(Button)`
  width: 156px;
  height: 48px;
  margin-top: ${Spacings.SPACING_8B};
`;

const getBulletPoints = (data, subHeader) => {
  return [
    ...(subHeader ? [subHeader] : []),
    `${data.questionCount} quick questions`,
    `Just ${data.testDuration} min`
  ];
};

type UnattemptedProps = {
  data: DST;
  takeTest: Function;
};

const Unattempted: FC<UnattemptedProps> = ({ data, takeTest }) => {
  const { header, subHeader } = data.extraBlockInfo || {};
  const bulletPoints = getBulletPoints(data.data[0], subHeader);

  return (
    <Container>
      <ContentDiv>
        <Heading>
          {header}
          <Image src="/dst/offer.svg" height={23} width={21} alt="offer" />
        </Heading>
        <SubHeader>
          The scholarship applies directly to your subscription
        </SubHeader>
        <Points>
          {bulletPoints.map((text) => {
            return (
              <Point key={text}>
                <Image
                  src="/dst/tick.svg"
                  height={20}
                  width={20}
                  alt="dst-points"
                />
                <Text>{text}</Text>
              </Point>
            );
          })}
        </Points>
        <StyledBtn
          // @ts-ignore
          label="Start test"
          variant="filled"
          color="black"
          onClick={takeTest}
        />
      </ContentDiv>
      <Image src="/dst/trophy.svg" height={178} width={260} alt="dst-trophy" />
    </Container>
  );
};

export default Unattempted;
